
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { fundmanagerapi } from "../../ApiNames";

export const fetchdatasuccess = (data: any) => ({
    type: 'fetch_data_success',
    payload: data,
});
export const fetchdatadialogsuccess = (reportdata: any) => ({
    type: 'fetch_data_Add_success',
    payload: reportdata,
});
export const fetchdata = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid: uid };
            const apiname = fundmanagerapi.fmdonorreports;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdatasuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchreportdata = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid: uid };
            const apiname = fundmanagerapi.genarate;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdatadialogsuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

